import App from './App.svelte'
import { config } from "./Store/ConfigStore"


// load config from wordpress
config.fromWordpress( culConfig )
const target = document.querySelector( culConfig.target )
const triggers = document.querySelectorAll( culConfig.guard_selector )

culConfig.debug && console.log( window.culConfig )
culConfig.debug && console.log( { target } )

// create the app
const app = new App( {
	target,
	props: { triggers }
} )

export default app
